exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".no-wrap td[data-v-0842bcdc],.no-wrap th[data-v-0842bcdc]{white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0842bcdc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/Pricing/bookingRespDashEdit.vue
// module id = 1365
// module chunks = 0